module.exports = __webpack_public_path__ + "static/media/23_shape_r.eca6b766.webp";